import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-wide, message, chat"><path d="M2.75 3.75H21.25V18.25H15.0155L11.9979 20.75L9.0155 18.25H2.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBubbleWide;
